import { useEffect, useCallback, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import close from "../../../assets/Icons/close.png";
import toothlensLogo from "../../../assets/illustrations/Toothlens Logo.jpeg";
import { markBeneficiaryCovered } from "../../../Services/APIs/patient";

const headingStyle = {
  color: "#2C3E50",
  fontFamily: "Poppins",
  fontWeight: "700",
  fontSize: "16px",
};

const thanksStyle = {
  color: "#2C3E50",
  fontFamily: "Poppins",
  fontWeight: "700",
};

const ThankYou = () => {
   const navigate = useNavigate();
   const { company: urlCompany } = useParams(); // Extract company from URL
   const [company, setCompany] = useState(() => urlCompany || localStorage.getItem("company") || "tl-star");
   const [cameraSide, setCameraSide] = useState(() => localStorage.getItem("cameraSide") || "front");

   const getNavigationPath = useCallback(() => {
    return `/group/${company}/${cameraSide}`;
  }, []);

  const handleNavigation = useCallback(() => {
    const path = getNavigationPath();
    navigate(path);
    setTimeout(() => {
      const insuranceLoginEmail = localStorage.getItem("insuranceLoginEmail");
      localStorage.clear();
      if (insuranceLoginEmail) {
        localStorage.setItem("insuranceLoginEmail", insuranceLoginEmail);
      }
    }, 100);
  }, [navigate, getNavigationPath]);

  
  useEffect(() => {
    // Mark this member's scan as completed in beneficiaries_covered
    const email = localStorage.getItem("insuranceLoginEmail");
    const uid = JSON.parse(localStorage.getItem("usertpi") || '{"usertpi":""}').usertpi;
    const insuranceCompany = localStorage.getItem("insuranceGroupCompany") || localStorage.getItem("company") || urlCompany;

    if (email && uid && insuranceCompany) {
      const formData = new FormData();
      formData.append("email", email);
      formData.append("uid", uid);
      formData.append("company", insuranceCompany);
      markBeneficiaryCovered(formData).catch(() => {});
    }

    // Clear localStorage on component unmount but preserve insuranceLoginEmail
    return () => {
      const insuranceLoginEmail = localStorage.getItem("insuranceLoginEmail");
      localStorage.clear();
      if (insuranceLoginEmail) {
        localStorage.setItem("insuranceLoginEmail", insuranceLoginEmail);
      }
    };
  }, [getNavigationPath]);

  return (
    <div className="h-screen bg-custom-gradient text-center flex flex-col justify-center items-center px-3 relative">
      
      <div className="absolute top-0 right-0 p-3">
        <button 
          type="button"
          onClick={handleNavigation}
          aria-label="Close"
          className="focus:outline-none hover:opacity-80 transition-opacity"
        >
          <img src={close} alt="Close" width="26" height="26" />
        </button>
      </div>

      <div className="flex justify-center"><img src={toothlensLogo} alt="ToothLens Logo" className="w-auto h-auto" /></div>
      
      <div className="flex justify-center">
        <div className="mt-8" style={headingStyle}>
          <p>Success! Your plan will be active within 24 hours. You can book your first dental appointment once activation is complete.</p>
          
        </div>
      </div>
      
      {/* Book Appointment Button */}
      <div className="flex justify-center my-6">
        <button
          onClick={() => window.open(`https://portal.toothlens.com`, '_blank')}
          className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-3 px-12 rounded-full transition-all duration-300 hover:shadow-lg hover:-translate-y-0.5 text-lg"
        >
          Back to Home
        </button>
      </div>
      
      <p className="mt-5 text-3xl" style={thanksStyle}>THANKS</p>

    </div>
  );
};

export default ThankYou;